module.exports = __webpack_public_path__ + "media/images/fact_sheet-f82d3fdf2f23b56250279d17c8d17cfd.png";